import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import PricingPage from '../pricing/PricingPage';

const PaymentPage = () => {

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Button 
              variant="ghost" 
              size="sm"
              onClick={() => window.location.href = '/dashboard'}
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Button>
            <h1 className="text-xl font-semibold">Choose Your Plan</h1>
          </div>
        </div>
      </div>

      {/* Main Content - Direct Pricing Page */}
      <div className="container mx-auto px-4 py-8">
        <PricingPage />
      </div>

      {/* Footer */}
      <div className="bg-white border-t mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-gray-600">
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Secure Payments</h3>
              <p>Your payment information is encrypted and secure. We never store your credit card details.</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">Money-Back Guarantee</h3>
              <p>Not satisfied? Get a full refund within 30 days of your purchase.</p>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-2">24/7 Support</h3>
              <p>Our support team is here to help you with any questions or issues.</p>
            </div>
          </div>
          
          <div className="border-t mt-8 pt-8 text-center text-xs text-gray-500">
            <p>© 2024 TavPlans Financial Modeling. All rights reserved.</p>
            <div className="flex justify-center gap-4 mt-2">
              <a href="/privacy" className="hover:text-gray-700">Privacy Policy</a>
              <a href="/terms" className="hover:text-gray-700">Terms of Service</a>
              <a href="/support" className="hover:text-gray-700">Support</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;